<template>
	<div class="tojpglimit_bc">
		<div class="tojpglimit_body">
			<!-- 按钮 -->
			<img
				src="./../../mycomponents/img/dialog/icon_syt_gb01@2x.png"
				alt=""
				@click="closeLimit()"
			/>
			<!-- 内容 -->
			<p>{{ $t("reminder") }}</p>
			<p>{{ $t("itcanonlybecompressedwithin50m") }}{{ routetype }}{{ $t("file") }}</p>
			<!-- 按钮 -->
			<div @click="closeLimit()">{{ $t("determine") }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "TojpgLimit",
	data() {
		return {routetype: ""};
	},
	methods: {
		closeLimit(flag) {
			this.$emit("close", flag);
		},
	},
	mounted() {
		if (this.$route.path == "/main/wordys") {
			this.routetype = "Word";
		} else if (this.$route.path == "/main/pptys") {
			this.routetype = "PPT";
		} else if (this.$route.path == "/main/pdfys") {
			this.routetype = "PDF";
		}
	},
};
</script>

<style lang="less">
.tojpglimit_bc {
	position: fixed;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	z-index: 9998;
	background: rgba(0, 0, 0, 0.4);
	display: flex;
	// display: none;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	.tojpglimit_body {
		display: flex;
		align-items: center;
		position: absolute;
		width: 360rem;
		height: 201rem;
		background: #ffffff;
		opacity: 1;
		z-index: 9999;
		flex-direction: column;
		border-radius: 8rem;
		img {
			width: 24rem;
			height: 30rem;
			position: absolute;
			top: 0;
			right: 4rem;
			cursor: pointer;
		}
		p {
			display: block;
			font-size: 14rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #5c7099;
			opacity: 1;
			// width: 100%;
			&:nth-of-type(1) {
				margin-top: 39rem;
				margin-bottom: 18rem;
			}
		}
		div {
			width: 200rem;
			height: 35rem;
			background: #006de0;
			opacity: 1;
			margin-top: 38rem;
			font-size: 16rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #ffffff;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			border-radius: 10rem;
			// flex-direction: column;
			&:hover {
				background-color: rgba(16, 129, 248, 1);
			}
			&:active {
				background-color: rgba(0, 100, 206, 1);
			}
		}
	}
}
</style>
